Vue.component('Modal', {
    template: '#modal-template',

    props: {
        show: Boolean,
        onClose: Function,
        large: Boolean,
        isCustomSwal: Boolean,
        xlarge: Boolean,
        closeOnBackdrop: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        containerClass() {
            if (this.xlarge) {
                return 'modal-container-xlarge';
            }

            return this.large
                ? 'modal-container-large'
                : 'modal-container';
        }
    },

    watch: {
        //added this watch to modal to prevent <body> scroll
        show() {
            if (this.show) {
                document.body.style.overflow = 'hidden';
                window._modalStack = window._modalStack || [];
                if (window._modalStack.indexOf(this) === -1) {
                    window._modalStack.push(this);
                }
                return;
            }

            window._modalStack = (window._modalStack || []).filter(m => m !== this);
            if (window._modalStack.length === 0) {
                document.body.style.overflow = '';
            }
        }
    },

    methods: {
        close() {
            if (!this.onClose) {
                return this.show = false;
            }

            this.onClose();
        },

        handleBackdropClick() {
            if (this.closeOnBackdrop === false) return;
            this.close();
        }
    },

    ready() {
        document.addEventListener("keydown", (e) => {
            if (this.show && this.closeOnBackdrop !== false && e.keyCode == 27) {
                const stack = window._modalStack || [];
                if (stack.length === 0 || stack[stack.length - 1] === this) {
                    this.close();
                }
            }
        });
    }
});
